const zhLang = {
  Basic: {
    Temp: "Temp",
  },
  Machine: {
    Equipment: "设备",
    MyEquipment: "我的设备",
    Alarm: "报警信息",
    Setting: "设置",
    Group: "设备组",
    Workshop: "车间",
    EquipmentGroup: "设备组",
    net: "联网",
    notNet: "未联网",
    Search: "搜索",
    All: "全部",
    Edit: "编辑",
    Done: "完成",
    Add: "新增",
    Run: "运行",
    Standby: "待机",
    Warning: "报警",
    Soft: "软启动",
    Auto: "PID再调整",
    Manual: "手动",
    Test: "测温",
    Stop: "停止",
    Name: "名称",
    Model: "型号",
    Serial: "序列号",
    EquipmentName: "请输入设备名称",
  },
  AddMachine: {
    GroupName: "组名",
    GroupSimple: "设备组",
    AddEquipment: "新增设备",
    SerireSimple: "序列号",
    InjectionWorkshop: "注塑车间",
    NoPower: "暂无权限控制",
    Parameter: "参数设置",
    EquipmentName: "设备名称",
    EquipmentModel: "设备型号",
    EquipmentNumber: "设备编号",
    EquipmentNumberInput: "请输入设备号",
    EquipmentSerialNumber: "设备序列号",
    Enable: "启用",
    Image: "图片",
    Operation: "操作",
    Cancel: "取消",
    selectEquipment: "请选择设备",
    inputSerialNumber: "请输入序列号",
  },
  TempTab: {
    EquipmentMatchingCode: "设备匹配码",
    Temp: "温度控制",
    Timer: "时序",
    SPM: "位移",
    RemoteOperationRecord: "远程操作记录",
  },
  Temp: {
    matchingCode: "请输入设备匹配码",
    Target: "目标",
    ControlSystem: "温控箱",
    All: "全选",
    Cancel: "取消选择",
    Control: "远程控制",
    Apply: "开启",
  },
  Timer: {
    Item: "项目",
    CH: "编号",
    Model: "模式",
    FirstInjection: "第一段注塑",
    SecondInjection: "第二段注塑",
    Delay1: "延迟1",
    Delay2: "延迟2",
    Open1: "打开1",
    Open2: "打开2",
    Close1: "关闭1",
    Close2: "关闭2",
  },
  Record: {
    ZoneNumber: "组编号",
    Temperature: "温度",
    Switch: "开关",
    Modifier: "修改者",
    ModificationTime: "修改时间",
  },
  Login: {
    Account: "账号",
    Password: "密码",
    SignIn: "登录",
    ForgotPassword: "忘记密码",
    Language: "语言",
    Email: "邮箱",
    MobilePhone: "手机号码",
    VerificationCode: "验证码",
    ResetPassword: "重设密码",
    ConfirmPassword: "确认密码",
    SendVerificationCode: "发送验证码",
    Backtologinpage: "返回登录页",
    OK: "确定",
    phoneNumber: "请输入手机号码",
    verificationCode: "请输入验证码",
    resetThePassword: "请输入重设密码",
    newpassword: "请确认新密码",
    inputPwd: "请输入用户密码",
  },
  UserInfo: {
    PersonalInformation: "个人信息",
    SuperAdministrator: "超级管理员",
    Administrators: "管理员",
    User: "用户",
    Users: "用户",
    UserName: "用户名称",
    Workshop: "所属车间",
    CurrentPassword: "旧密码",
    Account: "账户",
    NewPassword: "新密码",
    ChangePassword: "修改密码",
  },
  Warning: {
    StartTime: "开始时间",
    EndTime: "结束时间",
    ErrorTime: "错误时间",
    Error: "错误",
    NoData: "暂无数据",
    inputName: "请输入名称",
    selectTime: "请选择开始时间",
    selectEndTime: "请选择结束时间",
    ActualTemperature: "实际温度",
    SettedTemperature: "设定温度",
    Status: "状态",
    Output: "输出功率",
    Current: "电流",
    TemperatureHigh: "温度上限",
    TemperatureLow: "温度下限",
    Reset: "重置",
  },
  Setting: {
    User: "用户",
    DefaultWorkshop: "默认车间",
    CreationTime: "创建时间",
    ModificationTime: "修改时间",
    EditWorkshop: "修改车间",
    AddWorkshop: "新增车间",
    defaultDeleted: "默认车间无法删除",
    exists: "当前车间存在设备，不可删除",
    equipmentGroup: "请选择设备组",
    WorkshopInput: "请选择车间",
    WorkShopIp: "请输入车间名称",
    GroupQuantity: "设备组数量",
    GroupName: "设备组名称",
    addGroup: "新增设备组",
    editGroup: "编辑设备组",
    DefaultGroup: "默认设备组",
    equipmentDeleted: "默认设备组无法删除",
    cannotDeleted: "当前设备组存在设备，不可删除",
    EquipmentType: "设备类型",
    SerialNumber: "序列号",
    AddEquipment: "新增设备",
    CopyCode: "复制匹配码",
    MatchingCode: "匹配码",
    ChangeCode: "更换匹配码",
    EditEquipment: "编辑设备",
    UploadImage: "上传图像",
    InputModel: "请输入型号",
    serialNumber: "请输入序列号",
    RemovedSuccessfully: "删除成功",

    PhoneNumber: "手机号码",
    AddUser: "新增用户",
    EditUser: "编辑用户",
    IptAccout: "请输入账户名",
    Account: "账户",
    Role: "角色",
    Level: "等级",
    PowerControl: "权限控制",
    IpUserName: "请输入用户名",
    ErrEmail: "邮箱格式错误",
    IptEmail: "请输入邮箱",
    Control: "可远程控制",
    OnlyCheck: "仅查看",
    IpPwd: "请输入密码",
    oldPwd: "请输入旧密码",
    newPwd: "请输入新密码",
    Serial: "序列号",
    IptRole: "请选择角色",
    Biggest: "查看最大化图片",
  },
  Tip: {
    imageLimit: "上传图片只能是 JPG、JPEG、PNG 格式",
    CopySuccessful: "复制成功",
    CopyFailed: "复制失败",
    Blank: "账号或密码不能为空",
    Modified: "修改密码成功",
    Digits: "密码长度不能小于6位",
    Inconsistent: "重设密码和确认密码不一致",
    equipmentExceed: "设备名称字数不能超过20",
    modelExceed: "型号名称字数不能超过20",
    Format: "手机号码格式输入错误",
    IncorrectEmail: "邮箱输入有误",
    DeleteEquipment: "你确定要删除设备吗",
    WorkshopExceed: "车间名称字数不能超过20",
    Criteria: "请输入查询条件",
    GroupExceed: "设备组名称字数不能超过20",
    DeleteGroup: "你确定要删除设备组吗",
    DeleteUser: "你确定要删除用户吗",
    DeleteWorkshop: "你确定要删除车间吗",
    UserExceed: "用户名称字数不能超过20",
    AccountExceed: "账户名称字数不能超过20",
    AddSuccess: "新增成功",
    EditSuccess: "修改成功",
    SelectMachine: "请选择需要开启的设备",
    Tips: "提示",
    Loading: "加载中...",
    token: "Token 已过期",

    ALHigh: "温度过高",
    ALLow: "温度过低",
    ThermocoupleOpen: "热电偶开路",
    ThermocoupleReverse: "热电偶反向",
    ThermocoupleShort: "热电偶短路",
    HeaterOpen: "加热圈开路",
    HeaterShort: "加热圈短路",
    TriacBreakdown: "温可控硅击穿",
    FuseOpen: "保险丝断路",
    LeakageCurrent: "漏电故障",
    Mixed: "感温线和加热线混接",
    Default: "默认车间",
    overDate: "开始时间不能大于结束时间",
    removeTip: "请联系管理员到“设置-设备-编辑”页面中获取匹配码",
    isCheck: "模具检测中...",
    NetCorrect: "网络未连接",
    MachineNet: "设备未开启，无法查看",
    maxtemp_msg: "温度设定值不能超过{tempMsg}",
    mintemp_msg: "温度不能小于{tempMsg}",
    TempConfire: "点位未检测到感温线，确定打开？",
  },
  Update2: {
    groupSetting: "组设置",
    groupName: "组名称",
    addToGroup: "添加到组列表",
    tempOffset: "温度偏移量",
    increaseTemp: "增加温度偏移量",
    decreaseTemp: "降低温度偏移量",
    selectZone: "请选择点位",
    noRepeat: "不可重复添加组内容",
    share: "分享",
    import: "导入",
    export: "导出",
    fontSize: "字体大小",
    standard: "标准",
    medium: "中",
    large: "大",
    setGroup: "设置组",
    group: "组",
    editGroup: "编辑组",
    sort: "排序",
    name: "名称",
    tagColor: "标签颜色",
    groupInfo: "组信息",
    preStep: "上一步",
    nextStep: "下一步",
    allSelect: "全部",
    mulSelect: "多选",
    selectUsb: "请选择usb",
    selectExportFile: "请选择要导出的文件",
    selectImportFile: "请选择要导入的文件",
    addGroup: "添加到组",
    addGroupSuccess: "添加组成功",
    exportSuceess: "导出成功",
    importSuccess: "导入成功",
    inputName: "请填写组名称",
    confirmDelete: "确认删除吗",
    screening: "截图中",
  },
  FileDisplay: {
    FileName: "文件名称",
    textMode: "文本模式",
    drawingMode: "图纸模式",
    Open: "打开",
    Delay: "延迟",
    Mode: "模式",
  },
};

module.exports = zhLang;
